var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full"},[_c('TheNavigation'),(_vm.$route.path == '/')?_c('Header'):_c('HeaderSecondary'),_c('div',{},[_c('router-view',{key:_vm.$route.fullPath})],1),_c('TheFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }